import { defineStore } from 'pinia';
import api from '@/services/api';
import { getParamsUrl } from './usabilidad_utils';

export const useUsabilidadStore = defineStore('usabilidadStore', {
  state: () => ({
    entity: 'usabilidad',
    usabilidadLista: [],
    page: 1,
    filters: {},
  }),
  actions: {
    async findAllUsabilidadHTTP(params) {
      const result = await api.get(
        `/${this.entity}?${getParamsUrl({ page: +this.page, ...this.filters, ...params })}`,
      );
      if (result && result.data) {
        this.usabilidadLista.push(...result.data);
        this.setPage(this.page + 1);
        return true;
      }
      return false;
    },
    setPage(page) {
      this.page = page;
    },
    emptyList() {
      this.usabilidadLista = [];
    },
    setFilters(filters) {
      this.filters = filters;
    },
    resetFilters() {
      this.filters = {};
    },
  },
});
